import { StatusBadge } from "@/components/ui/badge"
import { Panel } from "@/components/ui/panel"

import type { AgendaSection as Section } from "../types"

const STATE_TONE = {
  open: "neutral",
  done: "confirmed",
  declined: "caution",
  skipped: "system",
} as const

/** One of the six sections: the lines to read, and the items Trumpet will score. */
export function AgendaSection({ section }: { section: Section }) {
  const singleItem =
    section.items.length === 1 && section.items[0].id === section.id
  return (
    <Panel id={section.id} title={section.label} headingLevel="h3">
      {section.lines.length > 0 && (
        <ul className="text-secondary flex list-disc flex-col gap-1.5 pl-5 text-sm">
          {section.lines.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      )}
      {!singleItem && section.items.length > 0 && (
        <ul className="flex flex-col gap-1.5">
          {section.items.map((item) => (
            <li
              key={item.id}
              className="flex items-center justify-between gap-3"
            >
              <span className="text-secondary text-sm">{item.label}</span>
              <StatusBadge tier={STATE_TONE[item.state]}>
                {item.state}
              </StatusBadge>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  )
}
